import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Button,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Modal,
  Chip,
} from "@mui/material";
import { ArrowsClockwise, DotsThree, Info, Trash } from "phosphor-react";
import useStyles from "../LicensesOverview/LicensesOverview.styles";
import LicenseInfoModal from "../LicensePageModals/LicenseInfoModal";

const ExpiredLicenseTableItem = ({ eachLicense }) => {
  const classes = useStyles();
  const [expiredLicenseToolsModal, setExpiredLicenseToolsModal] =
    useState(null);
  const [isLicenseInfoModal, setLicenseInfoModal] = useState(false);

  const handleLicenseInfoModal = () => {
    setLicenseInfoModal(!isLicenseInfoModal);
  };

  const handleExpiredLicenseToolsModal = (event) => {
    setExpiredLicenseToolsModal(event.currentTarget);
  };

  const handleCloseExpiredLicenseModal = () => {
    setExpiredLicenseToolsModal(null);
  };

  return (
    <>
      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
        <TableCell
          component="th"
          scope="row"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells}`}
        >
          <Typography variant="h5" fontWeight={600}>
            {eachLicense.license_number}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells} ${classes.tableRowCellsColor}`}
        >
          <Chip label={eachLicense.license_type} variant="outlined" />
        </TableCell>
        <TableCell
          align="center"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells} ${classes.tableRowCellsColor}`}
        >
          <Typography variant="h5">
            {eachLicense.user?.first_name} {eachLicense.user?.last_name}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells} ${classes.tableRowCellsColor}`}
        >
          <Typography variant="h5">
            {eachLicense.subscribed_on
              ? new Date(eachLicense.subscribed_on).toLocaleDateString(
                  "en-US",
                  {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  }
                )
              : "--"}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells} ${classes.tableRowCellsColor}`}
        >
          <Typography variant="h5" color="#E01717">
            {new Date(eachLicense.license_validity).toLocaleDateString(
              "en-US",
              {
                month: "long",
                day: "numeric",
                year: "numeric",
              }
            )}
          </Typography>
        </TableCell>
        <TableCell
          align="right"
          className={`${classes.tableRowHeadService} ${classes.tableRowCells}`}
        >
          <Button
            style={{
              margin: "0px",
              padding: "5px",
              minWidth: "0px",
              textTransform: "none",
              marginRight: "45px",
            }}
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              handleExpiredLicenseToolsModal(event);
            }}
          >
            <DotsThree size={20} color="#000000" />
          </Button>
        </TableCell>
      </TableRow>
      <Popover
        open={expiredLicenseToolsModal !== null}
        anchorEl={expiredLicenseToolsModal}
        onClose={handleCloseExpiredLicenseModal}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List
          style={{
            borderRadius: "10px",
            padding: "0px",
            height: "max-content",
            border: "1px solid #666666",
          }}
        >
          <ListItem button={true} onClick={handleLicenseInfoModal}>
            <ListItemIcon>
              <Info size={22} color="#000000" />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="h5" color="#000000">
                License Info
              </Typography>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem button={true} disabled>
            <ListItemIcon>
              <ArrowsClockwise size={22} color="#000000" />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="h5" color="#000000">
                Renew License
              </Typography>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem button={true} disabled>
            <ListItemIcon>
              <Trash size={22} color="#E01717" />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="h5" color="#E01717">
                Remove License
              </Typography>
            </ListItemText>
          </ListItem>
        </List>
      </Popover>
      <Modal
        open={isLicenseInfoModal}
        className={classes.centerContainer}
        onClose={handleLicenseInfoModal}
      >
        <LicenseInfoModal
          closeModal={handleLicenseInfoModal}
          licenseInfo={eachLicense}
        />
      </Modal>
    </>
  );
};

export default ExpiredLicenseTableItem;
